
$(() => {
	const textChangeDesktop = () => {
		const el = document.getElementById('changing-text');
		const divHeight = el.offsetHeight;
		const style = window.getComputedStyle(el);
		const lineh = style.getPropertyValue('line-height');
		const linei = parseInt(lineh,10);
		const lines = Math.ceil(divHeight / linei);
		let counter = lines;
		let topValue;
		let i;
		for (i = 0; i < lines; i++) {
			const intervalDesktop = setInterval(() => {
				if ( counter > 0) {
					counter--;
					topValue = counter*100;
					el.style.top = `-${topValue}%`;
				} else {
					counter = lines;
					el.style.top = `0%`;
				}
			}, 2000)
		}
	}

	const textChangeMobile = () => {
		const el = document.getElementById('changing-text');
		const innerSpans = $(el).children();
		let counter = 0;
		let paragraph = $(el).parent();
		let spans = [];
		// inner span filter
		innerSpans.each((index,element) => {
			if ($(element).prop('nodeName') == "SPAN" ) {
				spans.push(element)
			}
		})
		let top = 0;
		let lineHeight = 0; // initial line height 
		const intervalMobile = setInterval(() => {
			for(j = 0; j < spans.length; j++) {
				if (spans.length-1 >= counter) {
					if (counter == j) {
						let element = spans[j];
						let height = $(element).outerHeight();
						if (lineHeight == 0) {
							lineHeight = height;
						}
						if (lineHeight > height) {
							lineHeight = height;
						}
						el.style.top = `-${top}px`;
						el.style.lineHeight =  `${lineHeight}px`;
						setTimeout(()=>{
							paragraph.css('height',height+"px");
						},300)
						if (spans.length - 1 == counter) {
							top = 0;
							counter = 0;
							continue;
						} else {
							top += height;
							counter = counter + 1;
							break;
						}
					}
				} 
			}
		}, 2000)
	}
	$(window).on('load', () => {
		let windowSize = window.innerWidth;
		if (windowSize > 992) {
			textChangeDesktop();
		} else {
			textChangeMobile();
		}
	})
});
